import { MoonIcon, SunIcon } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import { Tooltip } from 'app/components/Tooltip'
import { Button } from 'app/components/ui/button'
import { useThemeToggle } from 'app/hooks/useThemeToggle'

/**
 * Icon button beside Log out in the classic sidebar user block; hidden entirely when dark
 * mode is unavailable. The icon names the mode a click switches to: moon in light, sun in dark.
 */
export const ThemeSwitch = observer(function ThemeSwitch() {
  const { available, ready, isDark, toggle } = useThemeToggle()

  if (!available) return null

  const Icon = isDark ? SunIcon : MoonIcon

  return (
    <Tooltip message={isDark ? `Light mode` : `Dark mode`} className="!cursor-pointer">
      <Button
        variant="subtle"
        size="icon-sm"
        role="switch"
        aria-label="Dark mode"
        aria-checked={isDark}
        disabled={!ready}
        onClick={toggle}
      >
        <Icon className="text-strong" aria-hidden="true" />
      </Button>
    </Tooltip>
  )
})
